function showStickyOffersFilter() {
    const stickyOfferFilter = $('.topFilters');
    const scrollHeight = $(".heroContainer").height() + $(".browseBy").height() + $(".carsFilter.top").height() + $(".paymentsFilter.top").height();

    if (stickyOfferFilter.length > 0) {
        if ($(document).scrollTop() > scrollHeight) {
            stickyOfferFilter.addClass("active");
        } else {
            stickyOfferFilter.removeClass("active");
        }
    }
}

$(document).ready(function () {
    showStickyOffersFilter();

    $(window).scroll(function() {
        showStickyOffersFilter();
    });
});


